import generateRandomId from 'utils/generateRandomId';

export const generateUnixTimestamp = ({ from, to }) => {
  if (!from || !to) return {};
  let fromTime = typeof from !== 'undefined' ? new Date(from).getTime() : from;
  let toTime = typeof to !== 'undefined' ? new Date(to).getTime() : to;
  fromTime = Math.round(fromTime / 1000);
  toTime = Math.round(toTime / 1000);
  return { fromTime, toTime };
};

export const generateHighlightMenuList = data => {
  const schema = [
    {
      category: {
        key: 'mapCRM',
        name: 'MAP/CRM',
      },
      subCategory: [
        {
          key: 'ziChat',
          name: 'Chat',
          distinctFields: [
            {
              key: 'defaultFields',
              name: 'Default Fields',
              fields: [],
            },
            {
              key: 'customFields',
              name: 'Custom Fields',
              fields: [],
            },
            {
              key: 'dynamicFields',
              name: 'Dynamic Fields',
              fields: [],
            },
            {
              key: 'accountFields',
              name: 'Account Fields',
              fields: [],
            },
          ],
        },
        {
          key: 'salesforce',
          name: 'Salesforce',
          distinctFields: [
            {
              key: 'recordInfo',
              name: 'SF Record Link',
              fields: [],
            },
            {
              key: 'ownerInfo',
              name: 'SF Owner Info',
              fields: [],
            },
            {
              key: 'opportunityFields',
              name: 'SF Opportunity Fields',
              fields: [],
            },
          ],
        },
        {
          key: 'hubspot',
          name: 'Hubspot',
          distinctFields: [
            {
              key: 'recordUrl',
              name: 'Hubspot Record Link',
              fields: [],
            },
            {
              key: 'owner',
              name: 'Hubspot Owner',
              fields: [],
            },
          ],
        },
      ],
    },
    {
      category: {
        key: 'ziIntelligence',
        name: 'ZI Intelligence',
      },
      subCategory: [
        {
          key: 'contact',
          name: 'Contact',
          fields: [],
        },
        {
          key: 'company',
          name: 'Company',
          logo: '',
          fields: [],
        },
        {
          key: 'intent',
          name: 'Intent',
          enableSearch: true,
          fields: [],
        },
        {
          key: 'technologies',
          name: 'Technologies',
          enableSearch: true,
          fields: [],
        },
      ],
    },
  ];
  // zi chat
  schema[0].subCategory[0].distinctFields[0].fields =
    data?.integrations?.ziChat?.defaultFields &&
    Array.isArray(data?.integrations?.ziChat?.defaultFields)
      ? data.integrations.ziChat.defaultFields.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  schema[0].subCategory[0].distinctFields[1].fields =
    data?.integrations?.ziChat?.customFields &&
    Array.isArray(data?.integrations?.ziChat?.customFields)
      ? data?.integrations?.ziChat?.customFields.map(field => ({
          ...field,
          id: generateRandomId(),
        }))
      : [];
  schema[0].subCategory[0].distinctFields[2].fields =
    data?.integrations?.ziChat?.dynamicFields &&
    Array.isArray(data?.integrations?.ziChat?.dynamicFields)
      ? data.integrations.ziChat.dynamicFields.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  schema[0].subCategory[0].distinctFields[3].fields =
    data?.integrations?.ziChat?.accountFields &&
    Array.isArray(data?.integrations?.ziChat?.accountFields)
      ? data.integrations.ziChat.accountFields.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  // salesforce
  schema[0].subCategory[1].distinctFields[0].fields =
    data?.integrations?.salesforce?.salesforceRecord &&
    Array.isArray(data?.integrations?.salesforce?.salesforceRecord)
      ? data.integrations.salesforce.salesforceRecord.map(field => ({
          ...field,
          id: generateRandomId(),
        }))
      : [];
  schema[0].subCategory[1].distinctFields[1].fields =
    data?.integrations?.salesforce?.salesforceOwner &&
    Array.isArray(data?.integrations?.salesforce?.salesforceOwner)
      ? data.integrations.salesforce.salesforceOwner.map(field => ({
          ...field,
          id: generateRandomId(),
        }))
      : [];
  schema[0].subCategory[1].distinctFields[2].fields =
    data?.integrations?.salesforce?.salesforceOpportunity &&
    Array.isArray(data?.integrations?.salesforce?.salesforceOpportunity)
      ? data.integrations.salesforce.salesforceOpportunity.map(field => ({
          ...field,
          id: generateRandomId(),
        }))
      : [];
  // hubspot
  schema[0].subCategory[2].distinctFields[0].fields =
    data?.integrations?.hubspot?.hubspotRecord &&
    Array.isArray(data?.integrations?.hubspot?.hubspotRecord)
      ? data.integrations.hubspot.hubspotRecord.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  schema[0].subCategory[2].distinctFields[1].fields =
    data?.integrations?.hubspot?.hubspotOwner &&
    Array.isArray(data?.integrations?.hubspot?.hubspotOwner)
      ? data.integrations.hubspot.hubspotOwner.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  // contact
  schema[1].subCategory[0].fields =
    data?.ziIntelligence?.contact && Array.isArray(data?.ziIntelligence?.contact)
      ? data.ziIntelligence.contact.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  // company
  schema[1].subCategory[1].fields =
    data?.ziIntelligence?.company && Array.isArray(data?.ziIntelligence?.company)
      ? data.ziIntelligence.company.map(field => ({ ...field, id: generateRandomId() }))
      : [];
  // intent
  schema[1].subCategory[2].fields =
    data?.ziIntelligence?.intents && Array.isArray(data?.ziIntelligence?.intents)
      ? data.ziIntelligence.intents.map(intent => ({ ...intent, id: generateRandomId() }))
      : [];
  // technologies
  schema[1].subCategory[3].fields = data?.ziIntelligence?.technologies || [];
  return schema;
};

export const generateFilesSchema = files => {
  return Array.isArray(files)
    ? files.map(({ createdAt, senderName, attachment }, index) => ({
        id: attachment?._id || index,
        name: attachment?.name || '',
        publicUrl: attachment?.publicUrl || '',
        size: attachment.size || '',
        createdAt: createdAt,
        type: attachment.type || '',
        senderName: senderName || '',
      }))
    : [];
};
